<template>
	<div class="container-xl">
		<main class="py-4">
			<div class="row g-3 mb-4 align-items-center justify-content-between">
				<div class="col-auto">
					<h1 class="app-page-title mb-0">{{ __('questionnaires.edit') }}</h1>
				</div>
				<div class="col-auto">
					<div class="page-utilities">
						<div class="row g-2 justify-content-start justify-content-md-end align-items-center">
							<div class="col-auto">
								<a class="btn btn-outline-success" @click.prevent="saveQuestionnaire()" href="#">
									<svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
										<path stroke-linecap="round" stroke-linejoin="round" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
									</svg>
									{{ __('questionnaires.save') }}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>

            <div class="row">
                <div class="col-12 col-md-12">
                    <div class="card mb-4">
                        <div class="card-header">
						    <div class="row justify-content-between align-items-center">
							    <div class="col-auto">
						            <h5 class="card-title">{{ __('questionnaires.configuration') }}</h5>
							    </div>
						    </div>
					    </div>
                        <div class="card-body">
                            <form class="settings-form">
                                <div class="form-check form-switch mb-3">
                                    <input class="form-check-input" id="settings-1" type="checkbox" v-model="questionnaire.is_active" name="is_active" :checked="questionnaire.is_active">
                                    <label class="form-check-label" for="settings-1">{{ __('questionnaires.is-active') }}</label>
                                </div>
                                <div class="form-check form-switch mb-3">
                                    <input class="form-check-input" id="settings-2" type="checkbox" v-model="questionnaire.show_has_passed" name="show_has_passed" :checked="questionnaire.show_has_passed">
                                    <label class="form-check-label" for="settings-2">{{ __('questionnaires.show-passed-field') }}</label>
                                </div>
                                <div class="mb-3">
									<label for="setting-input-3" class="form-label font-weight--bold">{{ __('questionnaires.name') }}</label>
									<input v-model="questionnaire.name" name="name" class="form-control" required>
								</div>
                                <div class="mb-3">
									<label for="setting-input-3" class="form-label font-weight--bold">Footer text</label>
									<textarea v-model="questionnaire.footer_text" name="footer_text" class="form-control" required></textarea>
								</div>
                            </form>
					    </div>
					</div>
                </div>
            </div>

            <draggable :list="questionnaire.questions" group="sections" handle=".handle">
                <div class="row" v-for="(section, index) in questionnaire.questions" :key="'section' + index">
                        <div class="col-md-12">
                            <div class="card mb-4">
                                <div class="card-header bg-white">
                                    <div class="d-flex justify-content-between">
                                        <h4 class="m-0">
                                            <a class="handle me-2" href="javascript:void(0)">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20">
                                                    <path fill="#4AA1CB" d="M512 256c0 6.797-2.891 13.28-7.938 17.84l-80 72C419.6 349.9 413.8 352 408 352c-3.312 0-6.625-.6875-9.766-2.078C389.6 346.1 384 337.5 384 328V288h-96v96l40-.0013c9.484 0 18.06 5.578 21.92 14.23s2.25 18.78-4.078 25.83l-72 80C269.3 509.1 262.8 512 255.1 512s-13.28-2.89-17.84-7.937l-71.1-80c-6.328-7.047-7.938-17.17-4.078-25.83s12.44-14.23 21.92-14.23l39.1 .0013V288H128v40c0 9.484-5.578 18.06-14.23 21.92C110.6 351.3 107.3 352 104 352c-5.812 0-11.56-2.109-16.06-6.156l-80-72C2.891 269.3 0 262.8 0 256s2.891-13.28 7.938-17.84l80-72C95 159.8 105.1 158.3 113.8 162.1C122.4 165.9 128 174.5 128 184V224h95.1V128l-39.1-.0013c-9.484 0-18.06-5.578-21.92-14.23S159.8 94.99 166.2 87.94l71.1-80c9.125-10.09 26.56-10.09 35.69 0l72 80c6.328 7.047 7.938 17.17 4.078 25.83s-12.44 14.23-21.92 14.23l-40 .0013V224H384V184c0-9.484 5.578-18.06 14.23-21.92c8.656-3.812 18.77-2.266 25.83 4.078l80 72C509.1 242.7 512 249.2 512 256z"/>
                                                </svg>
                                            </a>
                                            <span :key="section.title + index" class="section-title" @click="toggleSection(section.title)">{{ section.title }}</span>
                                        </h4>
                                        <div class="d-flex">
                                            <a href="" class="icon-btn text-secondary"
                                            v-on:click.prevent="editSection(section, index)">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                    <path
                                                        d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"/>
                                                </svg>
                                            </a>
                                            <a href="" class="icon-btn text-danger"
                                                v-on:click.prevent="deleteSection(section, index)">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fill-rule="evenodd"
                                                        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                                        clip-rule="evenodd"/>
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body py-4" v-if="opened.includes(section.title)">
                                    <draggable :list="section.questions" group="questions" handle=".handle">
                                        <div v-for="(question, questionIndex) in section.questions" :key="index + '-' + questionIndex">
                                            <div v-if="selectedQuestion.id === question.id" class="mb-3">
                                                <SurveyBuilder
                                                    :section-index="selectedQuestionSection"
                                                    :question-prop="selectedQuestion"
                                                    :question-types="questionTypes"
                                                    v-on:cancel="selectedQuestion = {id: null}; selectedQuestionSection = null;">
                                                </SurveyBuilder>
                                            </div>
                                            <div class="row mb-3" v-if="selectedQuestion.id !== question.id">
                                                <div class="col-md-12">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="d-flex justify-content-between">
                                                                <div class="d-flex align-items-center">
                                                                    <p class="mb-1">
                                                                        <a class="handle me-2" href="javascript:void(0)">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20">
                                                                                <path fill="#262261" d="M512 256c0 6.797-2.891 13.28-7.938 17.84l-80 72C419.6 349.9 413.8 352 408 352c-3.312 0-6.625-.6875-9.766-2.078C389.6 346.1 384 337.5 384 328V288h-96v96l40-.0013c9.484 0 18.06 5.578 21.92 14.23s2.25 18.78-4.078 25.83l-72 80C269.3 509.1 262.8 512 255.1 512s-13.28-2.89-17.84-7.937l-71.1-80c-6.328-7.047-7.938-17.17-4.078-25.83s12.44-14.23 21.92-14.23l39.1 .0013V288H128v40c0 9.484-5.578 18.06-14.23 21.92C110.6 351.3 107.3 352 104 352c-5.812 0-11.56-2.109-16.06-6.156l-80-72C2.891 269.3 0 262.8 0 256s2.891-13.28 7.938-17.84l80-72C95 159.8 105.1 158.3 113.8 162.1C122.4 165.9 128 174.5 128 184V224h95.1V128l-39.1-.0013c-9.484 0-18.06-5.578-21.92-14.23S159.8 94.99 166.2 87.94l71.1-80c9.125-10.09 26.56-10.09 35.69 0l72 80c6.328 7.047 7.938 17.17 4.078 25.83s-12.44 14.23-21.92 14.23l-40 .0013V224H384V184c0-9.484 5.578-18.06 14.23-21.92c8.656-3.812 18.77-2.266 25.83 4.078l80 72C509.1 242.7 512 249.2 512 256z"/>
                                                                            </svg>
                                                                        </a>{{ __('questionnaires.question') }}
                                                                        <span class="">{{ questionIndex + 1 }}:</span>
                                                                    </p>
                                                                    <span class="badge rounded-pill ms-2" :class="{ 'bg-danger': question.required, 'bg-info': !question.required}">{{ getQuestionTypeLabel(question.type)  }}</span>
                                                                </div>
                                                                <div class="d-flex">
                                                                    <a href="" class="icon-btn text-secondary"
                                                                    v-on:click.prevent="editQuestion(question, questionIndex, index)">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                                            <path
                                                                                d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"/>
                                                                        </svg>
                                                                    </a>
                                                                    <a href="" class="icon-btn text-danger"
                                                                    v-on:click.prevent="deleteQuestion(question, questionIndex, index)">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                                                            <path fill-rule="evenodd"
                                                                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                                                                clip-rule="evenodd"/>
                                                                        </svg>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            <div class="question-section">
                                                                <p class="mb-2">{{ question.body }}</p>
                                                            </div>
                                                            <div class="answer-section">
                                                                <div class="option-section" v-if="question.type === 'BOOLEAN'">
                                                                    <div class="" v-for='(option, index) in question.options' :key="index">
                                                                        <input type="radio" name="boolean_type" :disabled="readOnly">
                                                                        <label>{{ option.body }}</label>
                                                                    </div>
                                                                </div>
                                                                <div class="option-section" v-if="question.type === 'DATE'">
                                                                    <div class="p-0">
                                                                        <input type="text" class="form-control readonly" placeholder=""
                                                                            v-model="question.dateFormat" :readonly="readOnly">
                                                                    </div>
                                                                </div>
                                                                <div class="option-section" v-if="question.type === 'SINGLE_CHOICE' || question.type === '3_POINT_GRADING_SCALE' || question.type === '4_POINT_GRADING_SCALE'">
                                                                    <div v-for='(option, index) in question.options' :key="index">
                                                                        <label>
                                                                            <input type="radio" name="single"
                                                                                :disabled="readOnly">&nbsp;{{ option.body }}
                                                                        </label>
                                                                        <div class="" v-if="option.imageUrl">
                                                                            <img :src="option.imageUrl" alt="" class="">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="option-section" v-if="question.type === 'MULTI_CHOICE'">
                                                                    <div v-for='(option, index) in question.options' :key="index">
                                                                        <label>
                                                                            <input type="checkbox" :disabled="readOnly">&nbsp;{{ option.body }}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </draggable>
                                    <div v-if="section.addQuestion" class="mb-3">
                                        <SurveyBuilder
                                            :section-index="index"
                                            v-on:cancel="addNewQuestion(index, false)"
                                            :question-types="questionTypes"
                                        />
                                    </div>
                                    <div v-if="!section.addQuestion" class="text-center">
                                        <a class="btn app-btn-secondary" v-on:click.prevent="addNewQuestion(index, true)" href="#">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                            {{ __('questionnaires.add-question') }}
                                        </a>
                                    </div>
                                </div>

                        </div>
                    </div>
                </div>
            </draggable>
            <div class="mt-2 text-center">
                <a class="btn app-btn-secondary" data-bs-toggle="modal" data-bs-target="#createQuestionnaireModal" href="#">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {{ __('questionnaires.add-section') }}
                </a>
            </div>

		</main>
		<add-edit-section-modal @new-section="addNewSection" @update-section="updateSection" ref="sectionModal"></add-edit-section-modal>
	</div>
</template>

<script>
import SurveyBuilder from './survey-builder/SurveyBuilder';
import draggable from 'vuedraggable'

export default {
	props: {
		questionnaireProp: {
			type: Object,
			required: true,
		}
	},

	components: {
		SurveyBuilder,
		draggable
	},

	data() {
		return {
            opened: [],
			questionnaire: this.questionnaireProp,
			addQuestion: false,
			questionTypes: [
				{value: 'DEFAULT', label: this.__('questionnaires.question-default')},
				{value: 'BOOLEAN', label: this.__('questionnaires.question-boolean')},
				{value: 'MULTI_CHOICE', label: this.__('questionnaires.question-multiplechoice')},
				{value: 'SINGLE_CHOICE', label: this.__('questionnaires.question-singlechoice')},
				{value: '3_POINT_GRADING_SCALE', label: this.__('questionnaires.question-3pointgrading')},
                {value: '4_POINT_GRADING_SCALE', label: this.__('questionnaires.question-4pointgrading')},
				{value: 'NUMBER', label: this.__('questionnaires.question-number')},
				{value: 'TEXT', label: this.__('questionnaires.question-text')},
				{value: 'DATE', label: this.__('questionnaires.question-date')},
				{value: 'TIME', label: this.__('questionnaires.question-time')}
			],
			readOnly: true,
			selectedQuestion: {id: null},
			selectedQuestionSection: null,
            validation_errors: ''
		}
	},

    created() {
        this.questionnaire.questions.forEach(section => {
            this.toggleSection(section.title)
        })
    },
	mounted() {
		this.$root.$on('add-update-question', data => {
			this.updateQuestionsList(data);
		});
		this.$root.$on('selected-question', obj => {
			this.selectedQuestion = {id: null};
		});
	},

	methods: {
		addNewSection: function(data) {
			let section = {
				title: data.title,
				questions: [],
				addQuestion: false
			}
			this.questionnaire.questions.push(section)
			this.$refs.sectionModal.closeModal()
		},

		editSection: function (section, index) {
			this.$refs.sectionModal.editSection(section.title, index)
		},

		updateSection: function(section) {
			this.questionnaire.questions[section.index].title = section.title
			this.$refs.sectionModal.closeModal()
		},

        deleteSection(section, index) {
			Swal.fire({
				title: this.__('actions.confirm'),
                text: this.__('actions.confirm-text'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText:  this.__('actions.confirm-yes'),
                cancelButtonText:  this.__('actions.confirm-no'),
				showLoaderOnConfirm: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				reverseButtons: true,
			}).then(result => {
				if (result.value) {
                    this.$delete(this.questionnaire.questions, index);
				}
			})
		},

		togglePublish: function() {
			axios.post('/questionnaires/' + this.questionnaire.id + '/toggle-publish').then(response => {
				this.questionnaire.is_active = response.data.questionnaire.is_active;
				Toast.fire({icon: 'success', title: response.data.message})
			}).catch(error => {
				console.log(error);
			});
		},

        toggleSection: function(id, $event) {
            const index = this.opened.indexOf(id);
            if (index > -1) {
                this.opened.splice(index, 1)
            } else {
                this.opened.push(id)
            }
        },

		saveQuestionnaire() {
			axios.patch('/questionnaires/' + this.questionnaire.id, this.questionnaire).then(response => {
				Toast.fire({icon: 'success', title: response.data.message})
			}).catch(e => {
				this.validation_errors = e.response.data.errors.name
                Toast.fire({icon: 'error', title: this.validation_errors})
			});
		},

		updateQuestionsList(data) {
			let question = data.question
			console.log(question)
			const questionIndex = this.questionnaire.questions[data.index].questions.findIndex(x => x.id === question.id);
			if (questionIndex >= 0) {
				this.questionnaire.questions[data.index].questions.splice(questionIndex, 1, question);
			} else {
				this.questionnaire.questions[data.index].questions.push(JSON.parse(JSON.stringify(question)));
			}
			this.questionnaire.questions[data.index].addQuestion = false;
			this.$root.$emit('selected-question', null);
		},

		addNewQuestion(index, state) {
			this.questionnaire.questions[index].addQuestion = state;
			this.$set(this.questionnaire.questions, index, this.questionnaire.questions[index]);
		},

		getQuestionTypeLabel(type) {
			let quizType = this.questionTypes.filter(question => question.value === type)[0]
			if (quizType) {
				return quizType.label
			}
		},

		editQuestion(question, questionIndex,  index) {
			this.selectedQuestion = JSON.parse(JSON.stringify(question));
			this.selectedQuestion.questionNumber = questionIndex + 1;
			this.selectedQuestionSection = index
		},

		deleteQuestion(question, questionIndex, index) {
			Swal.fire({
				title: this.__('actions.confirm'),
                text: this.__('actions.confirm-text'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText:  this.__('actions.confirm-yes'),
                cancelButtonText:  this.__('actions.confirm-no'),
				showLoaderOnConfirm: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				reverseButtons: true,
			}).then(result => {
				if (result.value) {
					this.questionnaire.questions[index].questions.splice(questionIndex, 1);
				}
			})
		},
	}
}
</script>

<style lang="scss">
.icon-btn {
	svg {
		width: 20px;
		height: 20px;
	}
}

.section-title {
    cursor: pointer;
}
</style>
